<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.99479 2.92187L11.0781 7.00521L6.99479 11.0885" stroke="#93182F" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.91146 7L11.0781 7" stroke="#93182F" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
